<template>
  <div 
    v-if="show"
    class="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]"
    :class="containerClass"
  >
    <svg 
      class="relative block w-full"
      :class="svgHeightClass"
      viewBox="0 0 1200 120" 
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path 
        :d="wavePath"
        :class="fillClass"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface HeightConfig {
  mobile?: string
  desktop?: string
}

interface FillColorConfig {
  light?: string
  dark?: string
}

interface Props {
  /** Ob die Trennlinie angezeigt werden soll */
  show?: boolean
  /** Zusätzliche CSS-Klassen für den Container */
  containerClass?: string
  /** Höhe der SVG-Welle (mobile, desktop) */
  height?: HeightConfig
  /** Füllfarbe der Welle */
  fillColor?: FillColorConfig
  /** Art der Welle */
  variant?: 'smooth' | 'organic' | 'sharp'
}

const props = withDefaults(defineProps<Props>(), {
  show: true,
  containerClass: '',
  height: () => ({
    mobile: 'h-[60px]',
    desktop: 'md:h-[80px]'
  }),
  fillColor: () => ({
    light: 'fill-blue-50/40',
    dark: 'dark:fill-gray-800/40'
  }),
  variant: 'smooth'
})

/**
 * SVG-Pfade für verschiedene Wellen-Varianten
 */
const wavePaths: Record<string, string> = {
  smooth: 'M0,0 C200,50 400,50 600,25 C800,0 1000,0 1200,25 L1200,120 L0,120 Z',
  organic: 'M0,0 C150,40 350,60 600,30 C850,0 1050,10 1200,20 L1200,120 L0,120 Z',
  sharp: 'M0,0 L300,40 L600,20 L900,30 L1200,15 L1200,120 L0,120 Z'
}

const wavePath = computed(() => {
  return wavePaths[props.variant] || wavePaths.smooth
})

const svgHeightClass = computed(() => {
  const { mobile, desktop } = props.height
  return `${mobile || 'h-[60px]'} ${desktop || 'md:h-[80px]'}`
})

const fillClass = computed(() => {
  const { light, dark } = props.fillColor
  return `${light || 'fill-blue-50/40'} ${dark || 'dark:fill-gray-800/40'}`
})
</script>

